import React from "react";
import {useTranslation} from "react-i18next";
import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";
import {ToCustomDecimal} from "../../../AppSystem/Helpers/ToCustomDecimal";
import {CollapsibleSection} from "../../../Common/Components/Detail/CollapsibleSection";
import {DetailTable} from "../../../Common/Components/Detail/DetailTable";

const kr = (value) => `${ToCustomDecimal(value ?? 0)} kr`;

/*
Sections of an attest of model "Arvode": the yearly honorarium itself and its
payment plan.
*/
export function AttestHonorariumSections({data}) {
    const {t} = useTranslation();

    const queuedPayments = Array.isArray(data?.queuedPayments) ? data.queuedPayments : [];
    const intervalLabel = data?.paymentInterval === 12 ? t('modelLabel.monthly') : t('modelLabel.yearly');

    // Same pill treatment as the other tables of the detail view.
    const queuedStatusPill = (status) => {
        if (status === 'Utbetald') {
            return <div className="box-green reimbursement-status-pill-auto">{t('modelLabel.paidOut')}</div>;
        }
        if (status === 'Avbruten') {
            return <div className="box-red reimbursement-status-pill-auto">{t('honorarium.terminated')}</div>;
        }
        if (status === 'Obetald') {
            return <div className="box-custom-grey reimbursement-status-pill-auto">Inväntar datum</div>;
        }
        if (status === 'För granskning') {
            return <div className="box-custom-grey reimbursement-status-pill-auto">Inväntar utbetalning</div>;
        }
        return <div className="box-custom-grey reimbursement-status-pill-auto">{status}</div>;
    };

    return (
        <>
            <CollapsibleSection
                badge="A"
                title={t('honorarium.honorarium')}
                subtitle={intervalLabel}
                amountLabel={`${t('modelLabel.net')}:`}
                amount={kr(data?.net)}
            >
                <DetailTable
                    columns={[
                        {label: t('honorarium.payment'), role: 'title'},
                        {label: t('honorarium.annual'), align: 'right', nowrap: true},
                        {label: t('attest.employmentTaxShort'), align: 'right', nowrap: true},
                        {label: t('modelLabel.incomeTax'), align: 'right', nowrap: true},
                        {label: t('modelLabel.net'), align: 'right', nowrap: true, strong: true, role: 'amount'},
                        ...(data?.extraInfo ? [{label: t('honorarium.extraInfo')}] : []),
                    ]}
                    rows={[[
                        intervalLabel,
                        kr(data?.annualHonorarium),
                        kr(data?.employmentTax),
                        kr(data?.incomeTax),
                        kr(data?.net),
                        ...(data?.extraInfo ? [data.extraInfo] : []),
                    ]]}
                />
            </CollapsibleSection>

            {queuedPayments.length > 0 ?
                <CollapsibleSection
                    title={t('attest.paymentPlan')}
                    subtitle={t('honorarium.queued')}
                    amountLabel={`${t('modelLabel.total')}:`}
                    amount={kr(queuedPayments.reduce((total, item) => total + (item.value ?? 0), 0))}
                >
                    <DetailTable
                        columns={[
                            {label: t('modelLabel.date'), nowrap: true, role: 'title'},
                            {label: t('modelLabel.status'), nowrap: true},
                            {label: t('modelLabel.amount'), align: 'right', nowrap: true, strong: true, role: 'amount'},
                        ]}
                        rows={queuedPayments.map(item => [
                            ChangeDateFormat('date', item.date),
                            queuedStatusPill(item.status),
                            <span className="text-green">{kr(item.value)}</span>,
                        ])}
                    />
                </CollapsibleSection>
            : ''}
        </>
    );
}
